import HelsanaSwiper from './Classes/HelsanaSwiper';

import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Accordion from './Classes/Accordion';
import Highchart from '../node_modules/highcharts/highcharts'
import DrawHighchart from './Classes/DrawHighcharts';
import TabsDropdown from './Classes/TabsDropdown';
import TableCharts from './Classes/TableCharts';
import CountUpper from './Classes/CountUpper';
import Magazine from './Classes/Magazine';

// Initialize on document ready

var accordionInstance = null;

var responsiveTableInstance = null;


//window.addEventListener("DOMContentLoaded", function () {
window.addEventListener("page_event_load", function () {
  const hswiper = new HelsanaSwiper();

  console.log("page_event_load");

  new TabsDropdown();
  new CountUpper();

  new TableCharts();

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new DrawHighchart();

  accordionInstance = new Accordion({
		accordions: '.lc-accordion__inner-head',
		pxCorrectionMobile: 110,
		pxCorrectionDesktop: 105,
		mobileBreakpoint: 1025
	});

  new Magazine();
});

window.addEventListener('note_event_load', evt => {
  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });
});
